import * as paymentFrequencySelectors from '@makemydeal/dr-dash-store/selectors/paymentFrequencySelectors';
import { PaymentScheduleTypes } from '@makemydeal/dr-platform-types';
import { useSelector } from 'react-redux';

export const usePaymentFrequency = () => {
    const paymentFrequency = useSelector(paymentFrequencySelectors.getCalculatedPaymentFrequency);

    const isMonthly = paymentFrequency === PaymentScheduleTypes.Monthly;
    const isOnePayLease = paymentFrequency === PaymentScheduleTypes.OnePayLease;

    return {
        paymentFrequency,
        isMonthly,
        isOnePayLease
    };
};
